import { useQuery } from '@tanstack/react-query';
import { get } from '../../nucleo/api';
import type { Categoria, CentroCusto, Conta, Pagina } from './tipos';
import { rotuloCategoria } from '../../nucleo/rotulos';
import { opcoesCategoriasFinanceiro } from '../../nucleo/categorias-financeiro';

/** Listas pequenas usadas em filtros e formulários (chaves começam por /financeiro para invalidar junto). */
export function useContas(ativas = false) {
  return useQuery({ queryKey: ['/financeiro/contas', 'lista', ativas], queryFn: () => get<Pagina<Conta>>('/financeiro/contas', { ativa: ativas ? true : undefined }), staleTime: 30_000 });
}

export function useCategorias() {
  return useQuery(opcoesCategorias());
}

/** Review r25 robustez (M3): a árvore inteira, a mesma consulta do Contas (`useCategoriasFin`) na mesma chave. */
export const opcoesCategorias = () => opcoesCategoriasFinanceiro<Categoria>();

export function useCentros() {
  return useQuery({ queryKey: ['/financeiro/centros-custo', 'lista'], queryFn: () => get<Pagina<CentroCusto>>('/financeiro/centros-custo'), staleTime: 30_000 });
}

/**
 * Fase 2, W24 (K9): a categoria que recebe lançamento no seletor: ativa, do tipo certo, analítica (a sintética só agrupa) e
 * folha (o pai agrupa, o lançamento vai na filha).
 */
export function categoriaLancavel(c: Categoria, todas: Categoria[], tipo: Categoria['tipo']) {
  return c.tipo === tipo && c.ativa && !c.sintetica && !todas.some((f) => f.parent_id === c.id);
}

/** Nome da categoria com o caminho dos pais: "Despesas operacionais / Aluguel". */
export function caminhoDaCategoria(c: Categoria, todas: Categoria[]): string {
  const nomes = [rotuloCategoria(c.nome)];
  let atual: Categoria | undefined = c;
  for (let i = 0; i < 6 && atual?.parent_id; i++) {
    atual = todas.find((x) => x.id === atual!.parent_id);
    if (atual) nomes.unshift(rotuloCategoria(atual.nome));
  }
  return nomes.join(' / ');
}
